/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EditorProject
 */
export interface EditorProject {
    /**
     * 
     * @type {number}
     * @memberof EditorProject
     */
    file?: number;
    /**
     * 
     * @type {number}
     * @memberof EditorProject
     */
    parent?: number;
    /**
     * 
     * @type {string}
     * @memberof EditorProject
     */
    parentPath?: string;
    /**
     * 
     * @type {number}
     * @memberof EditorProject
     */
    existingFile?: number;
    /**
     * 
     * @type {string}
     * @memberof EditorProject
     */
    format?: string;
    /**
     * 
     * @type {object}
     * @memberof EditorProject
     */
    project: object;
}

export function EditorProjectFromJSON(json: any): EditorProject {
    return EditorProjectFromJSONTyped(json, false);
}

export function EditorProjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditorProject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : json['file'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'parentPath': !exists(json, 'parent_path') ? undefined : json['parent_path'],
        'existingFile': !exists(json, 'existing_file') ? undefined : json['existing_file'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'project': json['project'],
    };
}

export function EditorProjectToJSON(value?: EditorProject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': value.file,
        'parent': value.parent,
        'parent_path': value.parentPath,
        'existing_file': value.existingFile,
        'format': value.format,
        'project': value.project,
    };
}


